var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Isolation_Mode",
    "data-name": "Isolation Mode",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 486.92 499.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 243.18,
    cy: 132.63,
    r: 132.63
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.41,340.45c-45.36-24.62-105.36-38.18-168.95-38.18s-123.59,13.56-168.95,38.18C26.46,366.53,0,402.16,0,440.79v.57c.22,32.12,26.75,58.26,59.13,58.26H427.79c32.38,0,58.91-26.13,59.13-58.25v-.58c0-38.62-26.46-74.26-74.51-100.34Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/AccountIcon.dc228836d445367d484d619c18a73175.svg";
export { ForwardRef as ReactComponent };